import React from 'react';
import { connect } from 'react-redux';
import { buildRelatedEntitiesQueries } from 'utils/dictionaryHelpers';
import RelatedEntitiesList from 'components/RelatedEntitiesList';
import { BIOSPECIMEN_ORDER, SUBMITTABLE_DATA_FILES_ORDER } from 'constants/constants';

let getRelatedEntities = ({ defs, entityType, fetchedData }) => {
  let { filteredDefs } = buildRelatedEntitiesQueries({
    defs, entityType
  });

  let relatedEntities = Object.keys(fetchedData)
    .filter(key => fetchedData[key])
    .map(key => ({
      category: (filteredDefs.find(x => x.id === key) || {}).category,
      type: key,
      count: fetchedData[key]
    }));

  return relatedEntities;
};

function RelatedEntitiesContainer({
  relatedEntities: { relatedEntities: fetchedData },
  entityDefinitions: { defs },
  entityType,
  entityId
}) {
  let relatedEntities = getRelatedEntities({ defs, entityType, fetchedData });

  const order = [
    ...BIOSPECIMEN_ORDER,
    ...SUBMITTABLE_DATA_FILES_ORDER,
    'annotation'
  ];
  relatedEntities.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type));

  return (
    relatedEntities.length
      ? <RelatedEntitiesList entityId={entityId}>{relatedEntities}</RelatedEntitiesList>
      : <div>No Related Entities</div>
  );
}


export default connect(
  state => ({
    relatedEntities: state.relatedEntities,
    entityDefinitions: state.entityDefinitions
  })
)(RelatedEntitiesContainer);
